import { render, staticRenderFns } from "./SmallChartModal.vue?vue&type=template&id=46037500&scoped=true&"
import script from "./SmallChartModal.vue?vue&type=script&lang=js&"
export * from "./SmallChartModal.vue?vue&type=script&lang=js&"
import style0 from "./SmallChartModal.vue?vue&type=style&index=0&id=46037500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46037500",
  null
  
)

export default component.exports